export default __webpack_public_path__ + "static/media/reims16.e1563426.jpg";